module.exports = __webpack_public_path__ + "img/3cb-l-1p-re.f62bcb5a.png";